<template>
  <el-dialog
      v-model="dialogVisible"
      align-center
      width="600px"
      class="login-content">

    <template #header="{ close, titleId, titleClass }">
      <div class="my-header">
        <h2 style="text-align: center">用户注册</h2>
      </div>
    </template>
    <div class="login-section">
      <el-form label-width="100px" class="demo-ruleForm"
               :rules="rules"
               :model="rulesForm"
               status-icon
               ref="ruleForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="手机号" prop="mobile">
              <el-input type="mobile" v-model="rulesForm.mobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="密码" prop="password">
              <el-input type="password" v-model="rulesForm.password"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="公司名称" prop="name">
              <el-input type="name" v-model="rulesForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="联系人" prop="linkman">
              <el-input type="linkman" v-model="rulesForm.linkman"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button>重置</el-button>
        </el-form-item>

      </el-form>
    </div>


  </el-dialog>
</template>

<script>
import {ref} from 'vue'
import {register} from "@/api/Patent";

export default {
  setup(props) {
    const dialogVisible = ref(false)

    // 手机号码自定义验证规则
    const telValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    // 密码正则表达式
    const passwordValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(value)) {
        callback(new Error("密码格式不正确，至少八个字符，至少一个字母和一个数字"));
      } else {
        callback();
      }
    };

  



    const rules = {
      mobile: [
        {required: true, message: '请输入手机号', trigger: "blur"},
        {validator: telValidator, message: '手机号格式不正确', trigger: "blur"}
      ],
      name: [
        {required: true, message: '请输入公司名称', trigger: "blur"},
      ],
      password: [
        {required: true, message: '请输入密码', trigger: "blur"},
        {validator: passwordValidator, message: '密码格式不正确，至少八个字符，至少一个字母和一个数字', trigger: "blur"}
      ],
      linkman: [
        {required: true, message: '请输入联系人', trigger: "blur"},
      ]
    }
    return {dialogVisible,  rules};
  },
  props: {
    registerFormClick: {
      type: Number,
      default: 0
    },
  },
  watch: {
    registerFormClick() {
      this.dialogVisible = true
    }
  },
  data() {
    return {
      rulesForm: {
        name: '',
        password: '',
        mobile: '',
        linkman: ''
      },

    };
  },
  methods: {
    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          //如果校检通过，在这里向后端发送用户名和密码
          register({
            name: this.rulesForm.name,
            password: this.rulesForm.password,
            mobile: this.rulesForm.mobile,
            linkman: this.rulesForm.linkman,
          }).then((data) => {
            console.log(data)

            if(data.success){
              this.dialogVisible = false;
              this.$message.success(data.msg)
            }else{
              this.$message.error(data.msg)
            }
            /*if (data.code === 0) {
              localStorage.setItem('token', data.data.token);
              window.location.href = '/';
            }
            if (data.code === 1) {

            }*/
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }

}


</script>
<style lang="less" scoped>

.login-section {

  padding: 0px 20px
}
</style>
